import { Grid, TextField } from "@mui/material";
import { ButtonCancel } from "components/buttons";
import { ButtonApplyFilter } from "components/buttons/ButtonApplyFilter";
import { MprcInputStyles } from "components/filter/MprcInputStyles";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { IAdvFilterPickerProps, IAdvFilterResult } from "views/general/AdvancedFilter/interfaces";

////////////////////////////////////////////////////////////////////////////////

export const TextFieldPicker: React.FC<IAdvFilterPickerProps> = (props) => {

    const { filter, onApply, onCancel } = props;

    const { t } = useTranslation("shared");

    const [selected, setSelected] = useState<string | null>(null);

    const textFieldRef = useRef<HTMLInputElement>(undefined);

    ////////////////////////////////////////////////////////////////////////////////

    ///
    const handleApply = () => {
        if (selected != null) {
            const newFilter: IAdvFilterResult = {
                command: filter!.command,
                optionalGroup: filter?.optionGroup,
                text: `${filter?.displayName.replace("...", "")}: ${selected}`,
                value: selected,
                quickFilter: null,
                period: null,
                range: null,
                includeDescendants: null
            };
            onApply(newFilter, filter);
        }
    };

    useEffect(() => {
        textFieldRef.current?.focus();
    }, [textFieldRef]);

    ////////////////////////////////////////////////////////////////////////////////
    /// RENDER
    ////////////////////////////////////////////////////////////////////////////////

    return (
        <Grid container alignItems="flex-end" spacing={2}>
            <Grid size="grow">
                <TextField
                    autoComplete="off"
                    autoCorrect="off"
                    inputRef={textFieldRef}
                    fullWidth
                    autoFocus
                    value={selected}
                    placeholder={filter.placeholder ?? t("AdvFilter.Picker.TextField.Placeholder")}
                    onChange={(e) => setSelected(e.target.value)}
                    onKeyDown={(e) => {
                        if (e.key == "Enter") handleApply();
                        else if (e.key == "Escape") onCancel();
                    }}
                    sx={MprcInputStyles.filter}
                />
            </Grid>
            <Grid>
                <ButtonApplyFilter
                    variant="text"
                    disabled={selected == null || selected.trim().length == 0}
                    onClick={handleApply}
                />
                <ButtonCancel
                    variant="text"
                    onClick={onCancel}
                />
            </Grid>
        </Grid>
    );
};
